import { Config } from '@adornis/config/config.js';

export const config = new Config('smartteams-app', {
  MAPBOX_ACCESS_TOKEN: { name: 'MAPBOX_ACCESS_TOKEN', env: true, client: true, required: false, defaultVal: '', yesICheckedThatThisISActuallyNotASecretEnvVarAndShouldBeExposedToTheClientIWillNotBeDecapitatedByTheAdornisTeam: true },
  // Not marked required: the app boots in every environment, but the inbound ServiceNow
  // webhook only authenticates where the secret is actually set (handler returns 503 otherwise).
  SERVICENOW_WEBHOOK_SECRET: { name: 'SERVICENOW_WEBHOOK_SECRET', env: true, client: false, required: false, defaultVal: '' },
});
